export const TOKEN_STORE = "TOKEN_STORE"
export const TOKEN_REMOVE = "TOKEN_REMOVE"
export const TOKEN_CHECKED = "TOKEN_CHECKED"
export const URL_CHANGE = "URL_CHANGE"
export const CUSTOMER_SELECTED = "CUSTOMER_SELECTED"
export const CUSTOMER_REMOVED = "CUSTOMER_REMOVED"
